export enum FfmpegMessageType {
  START_PROCESSING = 'start-processing',
  DONE_PROCESSING = 'done-processing',
  FAILED_PROCESSING = 'failed-processing',
  START_EXTRACT_SEEKER_THUMBNAILS = 'start-extract-seeker-thumbnails',
  DONE_EXTRACT_SEEKER_THUMBNAILS = 'done-extract-seeker-thumbnails',
}

export interface VideoRange {
  lower: number;
  upper: number;
}

export interface FfmpegWorkerInput {
  type: FfmpegMessageType.START_PROCESSING;
  videoInput: Blob;
  videoRange: VideoRange;
}

export interface FfmpegWorkerSeekerThumbnailInput {
  type: FfmpegMessageType.START_EXTRACT_SEEKER_THUMBNAILS;
  videoInput: Blob;
}

export interface FfmpegWorkerOutput {
  type: FfmpegMessageType.DONE_PROCESSING;
  videoOutput: Blob;
}

export interface FfmpegWorkerSeekerThumbnailOutput {
  type: FfmpegMessageType.DONE_EXTRACT_SEEKER_THUMBNAILS;
  thumbnails: Blob[];
}

export interface FfmpegWorkerFailed {
  type: FfmpegMessageType.FAILED_PROCESSING;
  err: Error;
}
